module.exports = __webpack_public_path__ + "img/sem-uso.0d72388a.png";